import { P, Particles, Rng, type FxMeta } from "pixelfx";

/** Дым исчезновения: серые полупрозрачные клубы поднимаются и тают. Без белой вспышки — бойцы видны сквозь него. */
export const meta: FxMeta & { options: Record<string, unknown> } = {
  name: "Smoke puff",
  duration: 1.8,
  loop: false,
  fps: 30,
  size: [80, 80],
  origin: [40, 60],
  options: { seed: 1, count: 14 },
};

interface SmokeOptions {
  seed: number;
  count: number;
}

export function create(options: SmokeOptions): { update(dt: number): void; draw(painter: unknown): void } {
  const random = new Rng(options.seed);
  const particles = new Particles({ rng: random, ground: () => 30 });
  for (let index = 0; index < options.count; index++) {
    particles.spawn(
      P.SMOKE ?? 0,
      random.range(-8, 8),
      random.range(-6, 14),
      random.range(-20, 20),
      random.range(-30, -10),
      random.range(0.9, 1.6),
      0,
      random.range(3, 6),
    );
  }
  return {
    update(dt: number): void {
      particles.update(dt);
    },
    draw(painter: unknown): void {
      particles.draw(painter);
    },
  };
}
